import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Consistent, clearly-visible back control used on every in-app page.
 * - Provide `to="/path"` for a direct link, OR
 * - omit `to` to fall back to history.back() (nav(-1)).
 */
export default function BackButton({ to, label = "Back", testid = "back-button", className = "" }) {
  const nav = useNavigate();
  const base =
    "inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full border border-border " +
    "bg-background/60 backdrop-blur-sm text-sm text-foreground/80 " +
    "hover:text-foreground hover:border-primary/50 hover:bg-background " +
    "transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60";
  const cls = `${base} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testid}>
        <ArrowLeft size={14} aria-hidden="true" /> <span>{label}</span>
      </Link>
    );
  }
  return (
    <button type="button" onClick={() => nav(-1)} className={cls} data-testid={testid}>
      <ArrowLeft size={14} aria-hidden="true" /> <span>{label}</span>
    </button>
  );
}
